import { isNodeV2 } from '@vedalib/editor'
import * as R from 'ramda'

import { updateBlock } from 'services/Store/Project/actions'
import { DeviceMode } from 'services/Store/Project/enums'
import { resetStyles } from 'services/Store/Project/mutators/node'
import { getBlock, getDeviceMode, getSelectedNodeIds } from 'services/Store/Project/selectors'
import type { Block } from 'services/Store/Project/types'
import store from 'services/Store/store'

export const onStyleReset = async () => {
  const state = store.getState().project
  const dispatch = store.dispatch
  const block = getBlock(state)
  const device = getDeviceMode(state)
  const selectedNodes = getSelectedNodeIds(state)
  const children = selectedNodes.map((id) => block?.schema.nodes[id]).filter(isNodeV2)
  if (block && device !== DeviceMode.desktop) {
    const cbs = children.map((n) => resetStyles(n.id, device)) as [(block: Block) => Block]
    dispatch(updateBlock({ id: block.uuid, value: R.compose(...cbs)(block) }))
  }
}
